import React from "react";
const CheckoutIcon = (props) => {
    const { icon, text } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "checkout-icon-1" }, icon),
        React.createElement("div", { className: "checkout-icon-title-1" },
            React.createElement("h2", { className: "h4" }, text))));
};
export default CheckoutIcon;
